<template>
  <div class="fuel-funds__sidebar h-mobile-margin-top-24h-mobile-no-border-radius">
    <div class="fuel-funds__total-tag h-mobile-no-border-radius">
      <h3 class="h-big-dollar-sign">$</h3>
      <h1 class="fuel-funds__total">{{ totalAvailable }}</h1>
    </div>
    <div class="fuel-funds__available">
      <h2 class="fuel-funds__available--text">Available</h2>
    </div>
    <div class="fuel-funds__terms h-center-align">
      <p class="h-italic-text h-helper-text h-center-align">
        Deposits for Digital Promo funds will show up by the 15th of the following month. For example, if you qualified for the promo in January, you will see the deposit by February 15.
      </p>
      <span class="h-italic-text h-helper-text"><a @click.stop="activateModal">(Terms and Conditions)</a></span>
    </div>
    <hr class="h-mobile-medium-hidden">
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'DigitalPromoSidebar',
    components: {
    },
    computed: {
      ...mapGetters('digitalPromo', ['totalAvailable']),
    },
    methods: {
      activateModal() {
        this.$store.dispatch('main/showModal', 'digitalPromoTermsAndConditions');
      },
    },
  };
</script>

